import styled from "styled-components";
import { GREEN_BORDER, GREEN_TINT } from "../../constants/theme";

export const Section = styled.section`
  max-width: 1280px;
  margin: 0 auto;
  padding: 64px 16px;
`;
export const Cards = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr;
  @media (min-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
export const Card = styled.div`
  cursor: pointer;
  border: 1px solid ${GREEN_BORDER};
  border-radius: 16px;
  padding: 20px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  &:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
    transform: translateY(-4px);
  }
`;
export const CardHead = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 8px;
  span.icon {
    display: inline-flex;
    padding: 8px;
    border-radius: 12px;
    background: ${GREEN_TINT};
    color: #24ae7c;
  }
`;
export const CardTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
`;
export const CardSub = styled.div`
  font-size: 12px;
  color: #64748b;
`;
